/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION SITE THEME SECTION - SET THEME: STYLES --------------- ++++++++++ */
export default theme => ({
  language: {
    '& .link': {
      color: '#0034fd'
    },
    '& > .content': {
      gap: '16px'
    },
    '& .icon': {
      marginRight: '4px'
    },
    '& .inlimemessage': {
      '& .details': {
        alignItems: 'baseline'
      }
    }
  }
});
